import graphql__076a82ea073e81b15d42 from "./__generated__/CreateProjectDialogCustomerAccountsQuery.graphql.ts";
import graphql__92a7aba6fe273768a114 from "./__generated__/CreateProjectDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import type {CreateProjectDialogMutation} from "./__generated__/CreateProjectDialogMutation.graphql";
import {useNavigate} from "react-router-dom";
import {fetchQuery, useRelayEnvironment} from "react-relay/hooks";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import asFormikField from "../abstract/asFormikField";
import AbstractCombobox from "../abstract/AbstractCombobox";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type Props = {
    handleCloseDialog: () => void,
    query: any
}

const customerAccountsDataProvider = (relayEnvironment) => {
    return AwesomeDebouncePromise((searchTerm: string = '') => {
        return fetchQuery(relayEnvironment, graphql__076a82ea073e81b15d42, {searchTerm}).toPromise().then((data) => {
            if (!data) {
                return [];
            }
            //@ts-ignore
            return data.customerAccounts?.edges?.map((edge) => edge.node) || [];
        });
    }, 500);
}

const CreateProjectDialog: React.FC<Props> = ({handleCloseDialog, query}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateProjectDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__92a7aba6fe273768a114,
                variables: {
                    input: {
                        projectName: input.projectName,
                        customerAccountIdentifier: input.customerAccountIdentifier?.id || null
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                    // navigate('/projects/' + response.createProject?.id)
                    navigate('/projects')
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateProject'})
            }
        )
    }

    const initialValues = {
        projectName: '',
        customerAccountIdentifier: null
    }

    const validationSchema = yup.object().shape({
        projectName: yup.string()
            .min(2, intl.formatMessage({id: 'validation.field.nameTooShort'}))
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        customerAccountIdentifier: yup.object()
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    const CustomerAccountCombobox = asFormikField(AbstractCombobox, 'customerAccountIdentifier');

    return (
        <FormDialog handleCloseDialog={handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    headline={intl.formatMessage({id: 'dialog.CreateProjectDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateProjectDialog.projectNameLabel'})}</Label>
                    <Field name="projectName" type="text" autoFocus={true}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateProjectDialog.customerAccountLabel'})}</Label>
                    <CustomerAccountCombobox getEntryId={({id}) => id}
                                             getEntryLabel={({customerName}) => customerName}
                                             getEntrySecondaryLabel={({customerNumber}) => customerNumber}
                                             dataProvider={customerAccountsDataProvider(relayEnvironment)}
                                             placeholder={intl.formatMessage({id: 'dialog.CreateProjectDialog.searchCustomerPlaceholder'})}/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateProjectDialog;
